<template>
  <AppModalEdit
    v-model="isActive"
    :confirm-on-click-cancel="false"
    :is-exec-button-disabled="!form.isValid"
    @clickExec="onClickExec"
    @clickCancel="onClickCancel"
    title="アクセス元地域を選択してください"
    exec-button-text="保存"
  >
    <v-layout>
      <AppForm column>
        <v-radio-group v-model="ipAreaType">
          <v-radio
            v-for="type in ipAreaTypes"
            :key="type.value"
            :label="type.label"
            :value="type.value"
          />
        </v-radio-group>
      </AppForm>
    </v-layout>
    <v-layout v-if="isRegion" column>
      <AppTwoColumnsSelector
        :items="regions"
        :value="form.ipAreaIds"
        :is-show-all-select="true"
        @changeChosenItems="form.ipAreaIds = $event"
        available-label="都道府県一覧"
        chosen-label="選択済み地域"
        item-value="id"
      />
      <v-flex class="text-xs-right">
        <small v-if="form.emptyViolation" class="red--text">{{
          errorMessage
        }}</small>
      </v-flex>
    </v-layout>
  </AppModalEdit>
</template>

<script>
import { IpAreaTypes } from '@/models/CampaignOperation/Constants'
import { IpAreaSettingFormModel } from '@/models/CampaignOperation/Form'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    setting: {
      type: Object,
      required: true,
    },
    regions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: new IpAreaSettingFormModel(this.setting),
    }
  },
  computed: {
    ipAreaTypes() {
      return [
        {
          value: IpAreaTypes.COUNTRY,
          label: '日本全域',
        },
        {
          value: IpAreaTypes.REGION,
          label: '都道府県指定',
        },
      ]
    },
    ipAreaType: {
      get() {
        return this.form.ipAreaType
      },
      set(type) {
        this.form.changeIpAreaType(type)
      },
    },
    isRegion() {
      return this.form.ipAreaType === IpAreaTypes.REGION
    },
    isActive: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    errorMessage() {
      return this.form.emptyViolation
        ? 'アクセスエリアを日本全域にするか、都道府県を1つ以上設定してください。'
        : ''
    },
  },
  methods: {
    onClickExec() {
      this.$emit('change', this.form)
      this.isActive = false
    },
    onClickCancel() {
      this.isActive = false
    },
  },
}
</script>

<style scoped lang="scss"></style>
